import { AbstractInterface } from '../models/abstract.interface';

export enum GrantAction {
    Create = 'c',
    Read = 'r',
    Update = 'u',
    Delete = 'd',
    Manage = 'm'
}

export interface GrantInterface extends AbstractInterface {
    _roleId: number;
    actions: string;
    entityId?: number;
    entityName: string;

    can(action: GrantAction): boolean;
    enableAction(action: GrantAction): void;
    disableAction(action: GrantAction): void;
}
